import { getUserAdminRoles, updateUserAdminRoles } from '@lib/api'
import { userAdminRolesKeys, usersKeys } from '@lib/keys'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

// Only super admins may read these, so callers that can't be sure the signed-in
// user is one should pass `enabled: false` rather than provoke a 403.
export const useUserAdminRoles = (userId: number, enabled = true) => {
  return useQuery(
    userAdminRolesKeys.byUser(userId),
    () => getUserAdminRoles(userId),
    { enabled },
  )
}

export const useUpdateUserAdminRoles = (userId: number) => {
  const queryClient = useQueryClient()

  return useMutation(
    (adminRoles: Partial<UserAdminRoles>) =>
      updateUserAdminRoles(userId, adminRoles),
    {
      onSuccess: (adminRoles) => {
        queryClient.setQueryData(userAdminRolesKeys.byUser(userId), adminRoles)

        // A user's roles decide whether they are considered active
        void queryClient.invalidateQueries(usersKeys.all)
      },
    },
  )
}
